import React, { useRef, useState, useEffect } from 'react';
import { saveProduto } from '../../../services/ProdutosService';
import SwitchInput from '../../../components/SwitchInput/SwitchInput';
// import SelectProjeto from '../ProdutoModal/SelectProjeto';
// import SelectDotType from '../ProdutoModal/SelectDotType';

/**
 * props:
 * - data
 * - onSubmit
 */
function ProdutoModal(props) {

    const [error, setError] = useState('');
    const [produto, setProduto] = useState({});
    const [image, setImage] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
    const btnClose = useRef('');
    const btnSave = useRef('');

    const API_URL = process.env.REACT_APP_IMG_URL;
    const imagemUrl = `${API_URL}/api/images/`;

    function onSubmit(event) {
        const token = localStorage.getItem('token');
        const formData = new FormData();

        for (const key in produto) {
            formData.append(key, produto[key]);
        }
        if (image) {
            formData.append('imagen', image);
        }

        saveProduto(produto.id, formData, token)
            .then(result => {
                btnClose.current.click();
                if (props.onSubmit) props.onSubmit(result);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setError(err.response ? err.response.data : err.message);
            });
    }

    function onInputChange(event) {
        const { id, value } = event.target;
        setProduto(prevState => ({ ...prevState, [id]: value }));
    }

    function onImageChange(event) {
        const file = event.target.files[0];
        setImage(file);
        setImagePreviewUrl(URL.createObjectURL(file));
    }

    useEffect(() => {
        setProduto(props.data);
    }, [props.data.id]);

    return (
        <div className="modal fade" id="modalProduto" tabIndex="-1" role="dialog" aria-labelledby="modalTitleNotify" aria-hidden="false" data-bs-backdrop="static" data-bs-keyboard="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <h5 className="modal-title" id="modalTitleNotify">...::: {imagemUrl} :::...</h5> */}
                        <p className="modal-title" id="modalTitleNotify">{props.data.id ? 'Edit ' : 'New '}Tipo produto</p>
                        <button ref={btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            {/* <div className="row">
                                <div className="col-sm-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="sendGridKey">Projeto</label>
                                        <SelectProjeto id={produto.projetoId} onChange={onInputChange} />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="sendGridKey">Tipo do produto</label>
                                        <SelectDotType id={produto.dotTypesId} onChange={onInputChange} />
                                    </div>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="name">Nome:</label>
                                        <input type="text" id="nome" className="form-control" onChange={onInputChange} defaultValue={produto.nome} placeholder="Nome do produto" />
                                    </div>
                                </div>
                            </div>

                            {/* Deltalhes do produto */}
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="nome">NCM</label>
                                        <input className="form-control" id="ncm" type="text" placeholder="Código ncm" defaultValue={produto.ncm} onChange={onInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="descricao">Descrição</label>
                                        <input className="form-control" id="descricao" type="text" placeholder="Descrição do produto" defaultValue={produto.descricao} onChange={onInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <div>
                                    <label htmlFor="Quantidade">Quantidade</label>
                                    <input className="form-control" id="quantidade" type="text" placeholder="0,00" defaultValue={produto.quantidade} onChange={onInputChange} />
                                </div>
                            </div>
                            <div className="col-md-8 mb-3">
                                <div>
                                    <label htmlFor="Precov">Preço para venda</label>
                                    <input className="form-control" id="preco" type="text" placeholder="0,00" defaultValue={produto.preco} onChange={onInputChange} />
                                </div>
                            </div>
                            
                            {/* imagem do produto */}


                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="formFile" className="form-label">Imagem do produto</label>
                                    <input className="form-control" type="file" id="imagen" onChange={onImageChange} />
                                    {imagePreviewUrl && <img src={imagePreviewUrl} alt="Preview" className="img-thumbnail mt-2" />}
                                    <h1>Titulo de teste</h1>
                                    {produto.imagen && <img src={imagemUrl + produto.imagen} alt="Preview" className="img-thumbnail mt-2" />}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <SwitchInput id="isActive" text="Is Active?" onChange={onInputChange} isChecked={produto.isActive} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        {error && <div className="alert alert-danger mt-1 col-9 py-1">{error}</div>}
                        <button ref={btnSave} type="button" className="btn btn-sm btn-primary" onClick={onSubmit}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProdutoModal;
